import { Field } from '@components';
import { Customer } from '@models/customer';
import { Button, Drawer } from 'antd';
import React from 'react';

type Props = {
  customer?: Customer;
  visible: boolean;
  onClose: (id?: number) => any;
};

const CustomerDrawer: React.FC<Props> = ({ customer, visible, onClose }) => {
  return (
    <Drawer
      width={512}
      title="Customer"
      visible={visible}
      onClose={() => onClose()}
      closable={false}>
      <Field name="LIMS ID" value={customer?.lims} />
      <Field name="Customer Name" value={customer?.name} />
      <Field name="Address" value={customer?.address} />
      <Field name="City" value={customer?.city} />
      <Field name="State" value={customer?.state} />
      <Field name="Postal Code" value={customer?.postal_code} />
      <Field name="Country" value={customer?.country} />
      <div className="btn-group">
        <Button onClick={() => onClose()}>Back</Button>
        <Button onClick={() => onClose(customer?.id)} type="primary">
          Select
        </Button>
      </div>
    </Drawer>
  );
};

export default CustomerDrawer;
